import { cn } from '@liza/ui/utils';
import { ADDED_CLASS, REMOVED_CLASS, type NoteDiffPartView } from './noteDiffClasses';

/**
 * One run of text inside a rewritten segment.
 *
 * A marked run keeps its own padding and a small gap from its neighbour: a removal immediately
 * followed by its replacement otherwise renders as one unbroken word
 * (`experiencing anxietyfeeling anxious`), which is the exact spot a reader most needs to see two
 * distinct things. Whitespace-only runs render bare — padding a marked space would show as a
 * floating tint with nothing in it.
 */
export const DiffPart = ({ part }: { part: NoteDiffPartView }): React.ReactNode => {
  if (part.kind === 'unchanged') return part.value;
  const isAdded = part.kind === 'added';
  if (part.value.trim() === '') return part.value;
  return (
    <span
      className={cn('mx-0.5 rounded-[2px] px-0.5', isAdded ? ADDED_CLASS : REMOVED_CLASS)}
      data-testid={isAdded ? 'note-diff-added' : 'note-diff-removed'}
    >
      {part.value}
    </span>
  );
};
